module.exports = __webpack_public_path__ + "img/Tauchgruppe.1f910d56.svg";